import { LoanCriteria, LoanCriteriaList } from '@nemuru-eng/js-api-client';

import { ProductType } from '@/components/modules/Funnel/types/ProductType';
import { StepStats } from '@/components/modules/Funnel/types/StepStats';
import { getStepsDefinitions } from '@/components/modules/Funnel/utils/GetStepsDefinitions';
import { stepHasStatus } from '@/components/modules/Funnel/utils/StepHasStatus';
import { getLoanCriteriaProcessStatus } from '@/utils/getLoanCriteriaProcessStatus';
import { getOrderCriteriaProcessStatus } from '@/utils/getOrderCriteriaProcessStatus';
import { getProductCriteriaProcessStatus } from '@/utils/getProductCriteriaProcessStatus';

export const getStepStatsFromLoanList = (loanList: LoanCriteriaList['data'], selectedProductType: ProductType) => {
  const stepsStatsConstruct = [] as StepStats[];

  getStepsDefinitions(selectedProductType).forEach((step) =>
    stepsStatsConstruct.push({
      step: step,
      loans: [],
      totalAmount: 0,
      errors: 0,
      incidences: 0,
    }),
  );

  const getProcessStatus = (loan: LoanCriteria, productType: ProductType) => {
    switch (productType) {
      case ProductType.ORDER:
        return getOrderCriteriaProcessStatus(loan);
      case ProductType.ALL:
        return getProductCriteriaProcessStatus(loan);
      case ProductType.LOAN:
      default:
        return getLoanCriteriaProcessStatus(loan);
    }
  };

  const addLoanStats = async (loan: LoanCriteria) => {
    const processStatus = getProcessStatus(loan, selectedProductType);

    const statusIndexInStats = stepsStatsConstruct.findIndex((stepStats) =>
      stepHasStatus(stepStats.step, processStatus),
    );

    if (statusIndexInStats !== -1) {
      stepsStatsConstruct[statusIndexInStats].loans.push(loan);
      stepsStatsConstruct[statusIndexInStats].totalAmount += loan.loanConditions.principal.amount;
      stepsStatsConstruct[statusIndexInStats].errors += loan.errorDetected ? 1 : 0;
      stepsStatsConstruct[statusIndexInStats].incidences += loan.loanApplicationSelected?.isDocumentationWithIncidence
        ? 1
        : 0;
    } else {
      notFoundCount++;
    }
  };

  let filteredListAmount = 0;
  let notFoundCount = 0;

  loanList.forEach((loan) => {
    addLoanStats(loan);
    filteredListAmount = filteredListAmount + loan.loanConditions.principal.amount;
  });

  notFoundCount && console.log('getStepStatsFromLoanList notFoundCount with type', selectedProductType, notFoundCount);

  return stepsStatsConstruct;
};
